import styled from 'styled-components';
import ds from 'designsystem';
import { media } from 'designsystem/index';

/* Disable ESlint rule for this file */
/* eslint react/destructuring-assignment: "off" */

const Background = styled.div`
    width: 100%;
    background-color: ${props => props.color};
    overflow:hidden;
    padding-top: ${ds.get('metrics.base')};
    
    ${media.desktop`
      padding-top: 0;
    `}
`;

export default Background;



// WEBPACK FOOTER //
// ./src/blocks/Background/Background.jsx